import { Injectable } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';
import { IProduct } from '../interface/product.interface';
import { PRODUCTS_DATA } from '../database/products.data';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ProductIccService  {

  private apiUrl = environment.apiUrl+'/insurtech/project-configuration';
  private productsData: { [key: string]: IProduct } = {};
  private isDataLoaded = false;

  constructor(private http: HttpClient){
    this.loadProductsData()
  }

  private loadProductsData(): void {
    this.http.get<any>(this.apiUrl).pipe(
      map(response => {
        // Giả sử API trả về một mảng các sản phẩm như trong paste.txt
        // Bạn có thể cần điều chỉnh xử lý dữ liệu tùy theo cấu trúc response thực tế
        const products = response;
        const productsMap: { [key: string]: IProduct } = {};

        // Chuyển đổi mảng thành object với key
        products.forEach((product: IProduct, index: number) => {
          const key = `-product-${index}`;
          productsMap[key] = product;
        });

        return productsMap;
      }),
      catchError(error => {
        console.error('Error loading product data:', error);
        return of({});
      })
    ).subscribe(data => {
      this.productsData = data;
      this.isDataLoaded = true;
    });
  }


  getAll(): Observable<IProduct[]> {
    return this.ensureDataLoaded().pipe(
      map(() => {
        try {
          return Object.entries(this.productsData).map(([key, product]) => ({
            key,
            ...product
          }));
        } catch (error) {
          console.error(`getAll failed: ${error}`);
          return [];
        }
      })
    );
  }

  getById(key: string): Observable<IProduct | null> {
    return this.ensureDataLoaded().pipe(
      map(() => {
        try {
          const product = this.productsData[key];
          return product ? { key, ...product } : null;
        } catch (error) {
          console.error(`getById id=${key} failed: ${error}`);
          return null;
        }
      })
    );
  }

  getProductBySlug(slug: string): Observable<IProduct | null> {
    return this.ensureDataLoaded().pipe(
      map(() => {
        try {
          const product = Object.entries(this.productsData).find(([_, product]) =>
            product.slug === slug
          );

          if (product) {
            const [key, productData] = product;
            return { key, ...productData };
          }
          return null;
        } catch (error) {
          console.error(`getProductBySlug slug=${slug} failed: ${error}`);
          return null;
        }
      })
    );
  }

  getPublishedProducts(): Observable<IProduct[]> {
    return this.ensureDataLoaded().pipe(
      map(() => {
        return Object.values(this.productsData)
          .filter(product => product.publish);
      })
    );
  }

  isProductPublished(slug: string): Observable<boolean> {
    return this.ensureDataLoaded().pipe(
      map(() => {
        const productEntry = Object.entries(this.productsData).find(([_, product]) =>
          product.slug === slug
        );
        if (productEntry) {
          const [_, product] = productEntry;
          return !!product.publish;
        }
        return false;
      })
    );
  }

  isVoucherDisplayed(slug: string): Observable<boolean> {
    return this.ensureDataLoaded().pipe(
      map(() => {
        const productEntry = Object.entries(this.productsData).find(([_, product]) =>
          product.slug === slug
        );
        if (productEntry) {
          const [_, product] = productEntry;
          return !!product.showVoucher;
        }
        return false;
      })
    );
  }

  extractCurrentSlug(url: string): string {
    const urlParts = url.split('/');
    return urlParts[urlParts.length - 1];
  }

  // Phương thức này đảm bảo dữ liệu được tải trước khi thực hiện các thao tác khác
  private ensureDataLoaded(): Observable<void> {
    if (this.isDataLoaded) {
      return of(void 0);
    }

    return this.http.get<any>(this.apiUrl).pipe(
      map(response => {
        // Xử lý dữ liệu như trong loadProductsData
        const products = response;
        const productsMap: { [key: string]: IProduct } = {};

        products.forEach((product: IProduct, index: number) => {
          const key = `-product-${index}`; // Hoặc sử dụng ID từ API nếu có
          productsMap[key] = product;
        });

        this.productsData = productsMap;
        this.isDataLoaded = true;
      }),
      catchError(error => {
        console.error('Error loading product data:', error);
        this.productsData = {};
        this.isDataLoaded = true;
        return of(void 0);
      })
    );
  }


  // getAll(): Observable<IProduct[]> {
  //   try {
  //     const products = Object.entries(PRODUCTS_DATA).map(([key, product]) => ({
  //       key,
  //       ...product
  //     }));
  //     return of(products);
  //   } catch (error) {
  //     return this.handleError<IProduct[]>('getAll', [])(error);
  //   }
  // }

  // getById(key: string): Observable<IProduct | null> {
  //   try {
  //     const product = PRODUCTS_DATA[key];
  //     return of(product ? { key, ...product } : null);
  //   } catch (error) {
  //     return this.handleError<IProduct | null>(`getById id=${key}`)(error);
  //   }
  // }

  // getProductBySlug(slug: string): Observable<IProduct | null> {
  //   try {
  //     const product = Object.entries(PRODUCTS_DATA).find(([_, product]) =>
  //       product.slug === slug
  //     );

  //     if (product) {
  //       const [key, productData] = product;
  //       return of({ key, ...productData });
  //     }
  //     return of(null);
  //   } catch (error) {
  //     return this.handleError<IProduct | null>(`getProductBySlug slug=${slug}`)(error);
  //   }
  // }

  // private handleError<T>(operation = 'operation', result?: T) {
  //   return (error: any): Observable<T> => {
  //     console.error(`${operation} failed: ${error.message}`);
  //     return of(result as T);
  //   };
  // }

  // extractCurrentSlug(url: string): string {
  //   const urlParts = url.split('/');
  //   return urlParts[urlParts.length - 1];
  // }

  // /**
  //  * Lấy tất cả sản phẩm đã được publish
  //  * @returns Observable<IProduct[]> danh sách các sản phẩm đã publish
  //  */
  // getPublishedProducts(): Observable<IProduct[]> {
  //   return of(PRODUCTS_DATA).pipe(
  //     map(products =>
  //       Object.values(products)
  //         .filter(product => product.publish)
  //     )
  //   );
  // }

  // isProductPublished(slug: string): Observable<boolean> {
  //   return of(PRODUCTS_DATA).pipe(
  //     map(products => {
  //       const productEntry = Object.entries(products).find(([_, product]) =>
  //         product.slug === slug
  //       );
  //       if (productEntry) {
  //         const [_, product] = productEntry;
  //         return !!product.publish;
  //       }
  //       return false;
  //     })
  //   );
  // }

  // // Phương thức kiểm tra trạng thái showVoucher
  // isVoucherDisplayed(slug: string): Observable<boolean> {
  //   return of(PRODUCTS_DATA).pipe(
  //     map(products => {
  //       const productEntry = Object.entries(products).find(([_, product]) => product.slug === slug);
  //       if (productEntry) {
  //         const [_, product] = productEntry;
  //         return !!product.showVoucher;
  //       }
  //       return false;
  //     })
  //   );
  // }

  // currentSlug: string = '';
  // this.currentSlug = this.urlSlugService.extractCurrentSlug(window.location.href);

  // getAll(): Observable<IProduct[]> {
  //   return this.db.list<IProduct>(this.dbPath).snapshotChanges().pipe(
  //     map(changes => changes.map(c => ({ key: c.payload.key!, ...c.payload.val()! }))),
  //     catchError(this.handleError<IProduct[]>('getAll', []))
  //   );
  // }

  // getById(key: string): Observable<IProduct | null> {
  //   return this.db.object<IProduct>(`${this.dbPath}/${key}`).valueChanges().pipe(
  //     map(data => data ? { ...data, key } : null),
  //     catchError(this.handleError<IProduct | null>(`getById id=${key}`))
  //   );
  // }


  // getProductBySlug(slug: string): Observable<IProduct | null> {
  //   return this.db.list<IProduct>(this.dbPath, ref => ref.orderByChild('slug').equalTo(slug))
  //     .snapshotChanges()
  //     .pipe(
  //       map(changes => {
  //         if (changes.length > 0) {
  //           const change = changes[0];
  //           return { key: change.payload.key!, ...change.payload.val()! };
  //         }
  //         return null;
  //       }),
  //       catchError(this.handleError<IProduct | null>(`getProductBySlug slug=${slug}`))
  //     );
  // }

  // private handleError<T>(operation = 'operation', result?: T) {
  //   return (error: any): Observable<T> => {
  //     console.error(`${operation} failed: ${error.message}`);
  //     //có thể thêm logic để gửi lỗi đến service log ở đây
  //     return of(result as T);
  //   };
  // }

}
